export default __webpack_public_path__ + "static/media/rackham_thumb500px.cc86ed4a.jpg";